import { render, staticRenderFns } from "./globaldividenddistribution.vue?vue&type=template&id=3d0cb9ba&scoped=true"
import script from "./globaldividenddistribution.vue?vue&type=script&lang=js"
export * from "./globaldividenddistribution.vue?vue&type=script&lang=js"
import style0 from "./globaldividenddistribution.vue?vue&type=style&index=0&id=3d0cb9ba&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0cb9ba",
  null
  
)

export default component.exports